import React from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import placeholderImage from './assets/empty-result-placeholder.png';
import ActionCard from '../../Layouts/ActionCard';
import convertS3UrlToHttps from '../../utils/convertS3UrlToHttps';
import { FaMicroscope } from 'react-icons/fa6';
import { selectImageIds } from '../../Store/imageSlice';
import { openModal } from '../../Store/modalSlice';

interface EmptyResultProps {
    imageId: string;
    thumbnail_url: string | null
}

export default function EmptyResult(props: EmptyResultProps) {

    const { imageId, thumbnail_url } = props
    const { projectId } = useParams();
    const dispatch = useDispatch();

    const handleAnalyzeClick = () => {
        dispatch(selectImageIds([imageId]));
        dispatch(openModal({ type: "analyze", width: "lg", props: { projectId, clearSelectionOnClose: true } }));
    }

    return (
        <div className="card card-side bg-base-100">
            <div className="avatar p-4">
                <div className="w-24 rounded">
                    <img src={thumbnail_url ? convertS3UrlToHttps(thumbnail_url) : placeholderImage} alt="Preview Slide Thumbnail" />
                </div>
            </div>
            <div className="card-body">
                <div className='flex justify-between'>
                    <div className='p-4'>
                        <h2 className="card-title">Just uploaded!<div className="badge badge-accent">New</div></h2>
                        <p>Send it to Pathbox Cloud for analysis now!</p>
                    </div>
                    <div className="card-actions justify-end">
                        <ActionCard className='shadow-md bg-black text-white' title="Analyze" icon={<FaMicroscope />} onClick={handleAnalyzeClick}></ActionCard>
                    </div>
                </div>
            </div>
        </div>)
}